import { c as _c } from "react/compiler-runtime";
import { Avatar, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { getDifficultyColor } from "#/entities/difficulty/lib/getDifficultyColor";
import { difficultyLabels } from "#/entities/difficulty/model/difficultyLabels";
import type { RouterOutputs } from "#/shared/api";
import { getImageUrl } from "#/shared/lib";
import { NewLabel } from "#/shared/ui/atoms/NewLabel";
import { ProblemLinkButton } from "#/shared/ui/atoms/ProblemLinkButton";
export type ProjectInfoProps = {
  project?: RouterOutputs["project"]["getBySlug"];
};
export const ProjectInfo: React.FC<ProjectInfoProps> = t0 => {
  const $ = _c(27);
  const {
    project
  } = t0;
  const theme = useTheme();
  if (!project) {
    return null;
  }
  let t1;
  if ($[0] !== project.title) {
    t1 = <Typography>{project.title}</Typography>;
    $[0] = project.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== project.createdAt || $[3] !== project.isNew) {
    t2 = project.isNew && <NewLabel createdAt={project.createdAt} />;
    $[2] = project.createdAt;
    $[3] = project.isNew;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== project.lcLink) {
    t3 = project.lcLink && <ProblemLinkButton problemLink={project.lcLink} />;
    $[5] = project.lcLink;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Stack direction="row" alignItems="center" spacing={1}>{t1}{t2}{t3}</Stack>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== project.difficulty || $[12] !== theme) {
    t5 = getDifficultyColor(theme, project.difficulty);
    $[11] = project.difficulty;
    $[12] = theme;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = {
      opacity: 0.6,
      color: t5
    };
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = project.difficulty && difficultyLabels[project.difficulty];
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <Typography fontSize={12} variant="subtitle1" textOverflow="ellipsis" overflow="hidden" sx={t6}>{t7}</Typography>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== project.author) {
    t9 = project.author?.bucketImage && <Tooltip title={`Author: ${project.author.name}`} arrow={true}><Avatar src={getImageUrl(project.author.bucketImage)} alt={`${project.author.name} avatar`} sx={{
        height: 24,
        width: 24
      }} /></Tooltip>;
    $[19] = project.author;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <Stack direction="row" alignItems="center" minWidth={10} overflow="hidden" spacing={1}>{t8}{t9}</Stack>;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t4) {
    t11 = <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%" spacing={1}>{t4}{t10}</Stack>;
    $[24] = t10;
    $[25] = t4;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  return t11;
};